// client/src/utils/deviceLink.js
// Lien appareil <-> compte (cookie httpOnly posé par le serveur, invisible en JS).
// Voir functions/routes/deviceLink.js pour le principe.
import api from '../api';
import { auth } from '../firebase';

const REGISTERED_UID_KEY = 'ecobill_device_link_uid';
const XHR_HEADERS = { 'X-Requested-With': 'XMLHttpRequest' };
const RESOLVE_TIMEOUT_MS = 6000;

let registerInFlight = null;

function getRegisteredUid() {
  try { return sessionStorage.getItem(REGISTERED_UID_KEY); } catch { return null; }
}

function setRegisteredUid(uid) {
  try {
    if (uid) sessionStorage.setItem(REGISTERED_UID_KEY, uid);
    else sessionStorage.removeItem(REGISTERED_UID_KEY);
  } catch {}
}

/**
 * Associe l'appareil au compte connecté. Idempotent : un seul appel réseau par compte
 * et par session de navigation (évite de saturer le rate-limit en boutique).
 */
export async function registerDeviceLink({ force = false } = {}) {
  const uid = auth.currentUser?.uid;
  if (!uid) return false;
  if (!force && getRegisteredUid() === uid) return true;
  if (registerInFlight?.uid === uid) return registerInFlight.promise;

  const promise = (async () => {
    try {
      await api.post('/api/device-link/register', null, { headers: XHR_HEADERS });
      setRegisteredUid(uid);
      return true;
    } catch (error) {
      console.warn('[deviceLink] register failed:', error?.response?.status || error?.message);
      return false;
    } finally {
      registerInFlight = null;
    }
  })();
  registerInFlight = { uid, promise };
  return promise;
}

/** Retourne { customToken, uid } si l'appareil est associé à un compte, sinon null. */
export async function resolveDeviceLink() {
  try {
    const { data } = await api.post('/api/device-link/resolve', null, {
      headers: XHR_HEADERS,
      timeout: RESOLVE_TIMEOUT_MS,
    });
    return data?.customToken ? data : null;
  } catch (error) {
    const status = error?.response?.status;
    if (status !== 404) console.warn('[deviceLink] resolve error:', status || error?.message);
    return null;
  }
}

/** Détache l'appareil du compte (déconnexion volontaire). */
export async function forgetDeviceLink() {
  setRegisteredUid(null);
  try {
    await api.post('/api/device-link/forget', null, { headers: XHR_HEADERS, timeout: RESOLVE_TIMEOUT_MS });
  } catch (error) {
    console.warn('[deviceLink] forget failed:', error?.response?.status || error?.message);
  }
}
